const COMPANY_ORDER = [
	'contact',
	'activity',
	'todo',
	'phonecall',
	'appointment',
	'opportunity',
	'order',
	'agreement',
	'projectPlan'
];
const CONTACT_ORDER = ['activity', 'todo', 'phonecall', 'appointment', 'opportunity'];

export function rankByContext<T extends { type: string }>(
	actions: T[],
	context?: { type: 'company' | 'contact' }
): T[] {
	if (!context) {
		return actions;
	}
	const order = context.type === 'company' ? COMPANY_ORDER : CONTACT_ORDER;
	const orderSet = new Set(order);
	const contextual = order
		.map(type => actions.find(action => action.type === type))
		.filter((action): action is T => Boolean(action));
	const rest = actions.filter(action => !orderSet.has(action.type));
	return [...contextual, ...rest];
}
